import {CSSProperties, FC} from 'react';


export interface IIconAbsProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconAbs: FC<IIconAbsProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M7 4.517A9 9 0 0 1 12 3a9.01 9.01 0 0 1 9 9A9 9 0 1 1 7 4.517Zm.833 13.719A7.5 7.5 0 0 0 12 19.5a7.509 7.509 0 0 0 7.5-7.5 7.5 7.5 0 1 0-11.667 6.236Zm9.29-4.968c.126-.194.189-.415.189-.664 0-.271-.068-.496-.203-.673-.134-.18-.374-.347-.72-.503-.36-.165-.582-.278-.665-.34-.08-.063-.12-.133-.12-.212 0-.073.032-.134.096-.184.064-.05.166-.074.307-.074.273 0 .597.086.973.258l.332-.838a3.113 3.113 0 0 0-1.272-.288c-.47 0-.84.103-1.11.31-.269.207-.403.496-.403.865 0 .198.031.37.093.514.064.145.161.273.291.385.132.111.329.227.59.346.29.13.468.216.534.258a.488.488 0 0 1 .145.126c.031.04.047.088.047.143 0 .088-.038.16-.113.217-.075.055-.193.082-.354.082a2.44 2.44 0 0 1-.615-.087 3.296 3.296 0 0 1-.646-.25v.966c.196.094.385.16.566.198.181.037.406.055.673.055.32 0 .6-.053.838-.16.238-.107.42-.257.546-.45Zm-7.85.555-.198-.752H7.77l-.203.752H6.375l1.31-4.032h1.448l1.326 4.032H9.273Zm-.423-1.642-.173-.66c-.04-.146-.09-.336-.149-.568a9.832 9.832 0 0 1-.112-.5c-.017.094-.05.247-.1.462-.047.214-.154.636-.32 1.266h.854Zm2.046-2.373h1.4c.546 0 .95.081 1.215.244.265.161.398.413.398.755a.957.957 0 0 1-.173.577.771.771 0 0 1-.456.308v.027c.249.066.43.176.541.33.112.154.168.353.168.599 0 .364-.138.652-.413.862-.272.209-.645.313-1.117.313h-1.563V9.808Zm1.085 1.54h.327c.155 0 .275-.032.36-.096.086-.064.129-.159.129-.285 0-.226-.17-.338-.511-.338h-.305v.72Zm0 .794v.844h.382c.338 0 .508-.143.508-.429a.367.367 0 0 0-.138-.308c-.09-.071-.22-.107-.392-.107h-.36Z" clipRule="evenodd" />
        </svg>
    );
};
